<template>
  <div class="user-admin-setting-container">
    <div class="header-box">
      <div class="header-menu">
        <div><b style="font-size:28px; font-weight: 800;">Admin</b></div>
        <div style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;">ユーザー権限/追加</div>
      </div>
      <div class="button-wrapper">
        <b-dropdown aria-role="list">
          <button class="button" type="button" slot="trigger">
              <template>
                  <b-icon icon="menu"></b-icon>
                  <span class="-left-8px">ユーザー一覧画面 / メニュー</span>
              </template>
              <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item @click="changeModalCreateUser(true)" aria-role="listitem" v-if="user.permission===0">
              <div class="media">
                  <b-icon class="media-left" icon="account-multiple-plus"></b-icon>
                  <div class="media-content">
                      <p><b>ユーザーの追加</b></p>
                      <small>新しくユーザーを追加します</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="changeModalRestoreUser(true)" aria-role="listitem" v-if="user.permission===0">
              <div class="media">
                  <b-icon class="media-left" icon="account-check"></b-icon>
                  <div class="media-content">
                      <p><b>ユーザーの復帰</b></p>
                      <small>削除したユーザーを再登録します</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="changeModalImportUser(true)" aria-role="listitem" v-if="user.permission===0">
              <div class="media">
                  <b-icon class="media-left" icon="database-import"></b-icon>
                  <div class="media-content">
                      <p><b>ユーザーの一括追加</b></p>
                      <small>ユーザーをCSVデータを用いて<br>一括で追加します</small>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item @click="changeModalExportUser(true)" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="export"></b-icon>
                  <div class="media-content">
                      <p><b>ユーザーの情報エクスポート</b></p>
                      <small>ユーザーの情報をCSVデータにし、<br>ダウンロードします</small>
                  </div>
              </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <b-table
      responsive
      :class="{'admin-table': !isMenuMiniSize, 'admin-table-thin-menu': isMenuMiniSize}"
      class="disp-scroll"
      :data="users"
      :height="750">
        <b-table-column field="permission" label="権限" centered v-slot="props">
          <div style="width: 150px;"/>
          <span v-if="!users[users.indexOf(props.row)].isEditable && (props.row.permission===0 || props.row.permission===null || props.row.permission==='')">管理者</span>
          <span v-if="!users[users.indexOf(props.row)].isEditable && props.row.permission===1">編集者</span>
          <span v-if="!users[users.indexOf(props.row)].isEditable && props.row.permission===2">閲覧者</span>
          <span v-if="!users[users.indexOf(props.row)].isEditable && props.row.permission===3">ログイン不可</span>
          <b-select placeholder="権限を選択"
                    v-if="users[users.indexOf(props.row)].isEditable"
                    v-model="users[users.indexOf(props.row)].permission">
            <option
              v-for="(s, index) in select"
              :value="index"
              :key="index">
              {{ s }}
            </option>
          </b-select>
          <a class="mdi mdi-square-edit-outline" @click="users[users.indexOf(props.row)].isEditable=true; temp=users[users.indexOf(props.row)].permission" v-if="!users[users.indexOf(props.row)].isEditable&&user.permission===0"></a>
          <a class="mdi mdi-content-save" @click="changePermission(props.row)" v-if="users[users.indexOf(props.row)].isEditable"></a>
          <a class="mdi mdi-undo" @click="users[users.indexOf(props.row)].isEditable=false; users[users.indexOf(props.row)].permission=temp" v-if="users[users.indexOf(props.row)].isEditable"></a>
        </b-table-column>
        <b-table-column field="icon" label="アイコン" centered v-slot="props">
          <div style="width: 80px;"/>
          <img :src="props.row.icon">
        </b-table-column>
        <b-table-column field="username" label="名前" v-slot="props">
          <p style="text-align: left;">
            {{props.row.username}}
            <span style="font-size: 12px;" v-if="props.row.isConnect&&!props.row.isProvisional"><span class="isOnline"></span></span>
            <span style="font-size: 12px;" v-if="!props.row.isConnect&&!props.row.isProvisional"><span class="isOffline"></span></span>
            <span style="font-size: 12px;" v-if="props.row.isProvisional && props.row.permission < 3">
              <span style="font-size: 12px;" class="isOffline"></span>（仮登録）<br><a @click="resendEmail(props.row.email, props.row.username, props.row.permission)"><span class="mdi mdi-email"></span>再送</a>
            </span><br>
            <span style="font-size: 12px; color: #666;">{{props.row.email}}</span>
          </p>
        </b-table-column>
        <b-table-column field="departments" label="所属" v-slot="props">
          <div style="display: flex;" v-for="(d, i) in props.row.departments" :key="i">
            <p style="font-size: 13px; margin-right: 4px;">{{d.name}}</p>
            <button class="button is-small is-danger" @click="setDepartment(props.row.email, d.pk)">削除</button>
          </div>
          <DepartmentSet :email="props.row.email" :PCTRLLOG="CTRLLOG"/>
        </b-table-column>
        <b-table-column field="positions" label="役職" v-slot="props">
          <div style="display: flex;" v-for="(p, i) in props.row.positions" :key="i">
            <p style="font-size: 13px; margin-right: 4px;">{{p.name}}</p>
            <button class="button is-small is-danger" @click="setPosition(props.row.email, p.pk)">削除</button>
          </div>
          <PositionSet :email="props.row.email"  :PCTRLLOG="CTRLLOG"/>
        </b-table-column>
        <b-table-column field="isChatEnable" label="表示" centered v-slot="props">
          <b-switch
            type="is-primary"
            v-model="props.row.isChatEnable"
            @input="setPermission (users.indexOf(props.row), users[users.indexOf(props.row)].permission, props.row.isChatEnable, users[users.indexOf(props.row)].is_notify, users[users.indexOf(props.row)].isSeekerDisplayEnable, users[users.indexOf(props.row)].is_jobshare_filter)">
            {{getValue(props.row.isChatEnable)}}
          </b-switch>
        </b-table-column>
        <b-table-column field="is_notify" label="採用関連通知" centered v-slot="props">
          <b-switch
            style="width: 120px;"
            type="is-primary"
            v-model="props.row.is_notify"
            @input="setPermission (users.indexOf(props.row), users[users.indexOf(props.row)].permission, users[users.indexOf(props.row)].isChatEnable, props.row.is_notify, users[users.indexOf(props.row)].isSeekerDisplayEnable, users[users.indexOf(props.row)].is_jobshare_filter)">
            {{props.row.is_notify ? '通知有' : '通知無'}}
          </b-switch>
        </b-table-column>
        <b-table-column field="isSeekerDisplayEnable" label="応募者情報閲覧権限" centered v-slot="props">
          <b-switch
            style="width: 120px;"
            type="is-primary"
            v-model="props.row.isSeekerDisplayEnable"
            @input="setPermission (users.indexOf(props.row), users[users.indexOf(props.row)].permission, users[users.indexOf(props.row)].isChatEnable, users[users.indexOf(props.row)].is_notify, props.row.isSeekerDisplayEnable, users[users.indexOf(props.row)].is_jobshare_filter)">
            {{props.row.isSeekerDisplayEnable ? '権限有' : '権限無'}}
          </b-switch>
        </b-table-column>
        <b-table-column field="is_jobshare_filter" label="求人情報閲覧制御" centered v-slot="props">
          <b-switch
            style="width: 120px;"
            type="is-primary"
            v-model="props.row.is_jobshare_filter"
            @input="setPermission (users.indexOf(props.row), users[users.indexOf(props.row)].permission, users[users.indexOf(props.row)].isChatEnable, users[users.indexOf(props.row)].is_notify, users[users.indexOf(props.row)].isSeekerDisplayEnable, props.row.is_jobshare_filter)">
            {{props.row.is_jobshare_filter ? '制御有' : '制御無'}}
          </b-switch>
        </b-table-column>
        <template v-for="(t, i) in companyColumnSetting">
          <b-table-column :subheading="t.name" :label="displayHeader(i,t.is_authcontrol)" centered v-slot="props" :key="i + '-param3'" :id="'col-th-' + t.pk" v-if="t.is_authcontrol">
            <template v-for="c in users[users.indexOf(props.row)].u_custom">
              <div :key="c.pk + '-col27'" style="display:table">
                <div style="display:table-cell">
                  <template v-if="t.is_multiline">
                    <textarea
                      class="textarea is-small"
                      v-model="c.content"
                      @change="updateUserAuthColumn(users[users.indexOf(props.row)], t, c)"
                      :key="c.pk + '-col27'"
                      v-if="isMatchCol(users[users.indexOf(props.row)], t, c)"
                      :disabled="isMatchCol(users[users.indexOf(props.row)], t, c)">
                    </textarea>
                  </template>
                  <template v-else>
                    <input
                      class="input is-small"
                      v-model="c.content"
                      @change="updateUserAuthColumn(users[users.indexOf(props.row)], t, c)"
                      :key="c.pk + '-col27'"
                      v-if="isMatchCol(users[users.indexOf(props.row)], t, c)"
                      :disabled="isMatchCol(users[users.indexOf(props.row)], t, c)"/>
                  </template>
                </div>
                <div style="display:table-cell" v-if="isMatchCol(users[users.indexOf(props.row)], t, c)">
                  <button
                    class="button is-small is-danger"
                    style="display:table-cell;"
                    @click="deleteUserAuthColumn(users[users.indexOf(props.row)], t, c)"
                    :key="c.pk + '-col27'">削除</button>
                </div>
              </div>
            </template>
            <AuthUserSet :email="props.row.email" :col="t" :usr="users[users.indexOf(props.row)]" />
          </b-table-column>
        </template>
        <b-table-column field="is_active" label="削除" centered v-slot="props">
          <button class="button is-small is-danger"  @click="logicalDeleteUser(users.indexOf(props.row))">削除</button>
        </b-table-column>
    </b-table>
    <!-- モーダル部 -->
    <ModalCreateUser
      :isShowModal="isModalCreateUser"
      @cancel="changeModalCreateUser"
      @sendEmail="sendEmail"
      :PCTRLLOG="CTRLLOG"
    />
    <ModalRestoreUser
      :isShowModal="isModalRestoreUser"
      @cancel="changeModalRestoreUser"
      :PCTRLLOG="CTRLLOG"
    />
    <ModalImportUser
      :isShowModal="isModalImportUser"
      @cancel="changeModalImportUser"
      @importUser="importUser"
      :PCTRLLOG="CTRLLOG"
    />
    <ModalExportUser
      :isShowModal="isModalExportUser"
      @cancel="changeModalExportUser"
      @exportUser="exportUser"
    />
  </div>
</template>

<script>
import { mapState }    from 'vuex'
import ModalCreateUser from '@/components/Setting/organisms/ModalCreateUser'
import ModalRestoreUser from '@/components/Setting/organisms/ModalRestoreUser'
import ModalImportUser from '@/components/Setting/organisms/ModalImportUser'
import ModalExportUser from '@/components/Setting/organisms/ModalExportUser'
import { forEach } from 'lodash'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'UserAdminSetting',
  componentName: 'UserAdminSetting',
  components: {
    ModalCreateUser,
    ModalRestoreUser,
    ModalImportUser,
    ModalExportUser,
    DepartmentSet: {
      template: `
        <div style="display: flex;">
          <select class="select is-small" v-model="department">
            <option v-for="(d, i) in departments" :key="i" :value="d">
              {{d.name}}
            </option>
          </select>
          <button class="button is-small" @click="setDepartment()">追加</button>
        </div>
      `,
      mixins: [
        controlLogMixin
      ],
      computed: {
        ...mapState('auth', ['departments'])
      },
      props: ['email'],
      data () {
        return {
          department: null,
        }
      },
      methods: {
        setDepartment () {
          this.sendControlLog('ユーザー一覧　所属追加', 'ユーザー一覧画面にて、所属の「追加」ボタンをクリックした。')
          this.$store.dispatch('auth/setUsers',
            {
              'email': this.email,
              'department': this.department.pk,
              'is_add': true
            }
          )
        }
      }
    },
    PositionSet: {
      template: `
        <div style="display: flex;">
          <select class="select is-small" v-model="position">
            <option v-for="(p, i) in positions" :key="i" :value="p">
              {{p.name}}
            </option>
          </select>
          <button class="button is-small" @click="setPosition()">追加</button>
        </div>
      `,
      mixins: [
        controlLogMixin
      ],
      computed: {
        ...mapState('auth', ['positions'])
      },
      props: ['email'],
      data () {
        return {
          position: null
        }
      },
      methods: {
        setPosition () {
          this.sendControlLog('ユーザー一覧　役職追加', 'ユーザー一覧画面にて、役職の「追加」ボタンをクリックした。')
          this.$store.dispatch('auth/setUsers',
            {
              'email': this.email,
              'position': this.position.pk,
              'is_add': true
            }
          )
        }
      }
    },
    AuthUserSet: {
      template: `
        <div style="display: flex;">
          <input class="is-small" v-model="u_content">
          <button class="button is-small" @click="createUserAuthColumn()">追加</button>
        </div>
      `,
      props: ['email', 'col', 'usr'],
      data () {
        return {
          u_content: null,
        }
      },
      methods: {
        createUserAuthColumn () {
          console.error(this.usr)
          const createAuth = {
            name: this.col.name,
            type: 0,
            content: this.u_content,
            select_list: '',
            column: this.col.pk,
            email: this.email
          }
          this.$store.dispatch('auth/createUserCustomColumns', createAuth)
          this.u_content = null
        },
      }
    },
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('auth', ['user', 'error', 'success', 'users', 'errorMessage', 'companyColumnSetting']),
    ...mapState("setting",["isMenuMiniSize"]),
  },
  data () {
    return {
      temp: 0,
      isEdit: [],
      isModalCreateUser: false,
      isModalRestoreUser: false,
      isModalImportUser: false,
      isModalExportUser: false,
      isSecret: false,
      select: ['管理者', '編集者', '閲覧者', 'ログイン不可'],
      dispIdx: -1,
      dispHeaderAuth: '応募者閲覧権限設定'
    }
  },
  watch: {
    success () {
      if (this.success) {
        if (!alert('メンバーを新たに追加いたしました')) {
          this.changeModalCreateUser(false)
        }
        this.$store.dispatch('auth/getUsers')
        this.addEmail = ''
        this.addName = ''
        this.addPermission = 0
        this.isModalActive = false
      }
    },
    error () {
      if (this.error) {
        this.$buefy.snackbar.open({
          message: this.errorMessage,
          type: 'is-danger',
          position: 'is-top'
        })
        this.addEmail = ''
        this.isModalActive = false
      }
    }
  },
  created(){
    // 管理者権限以外のユーザーには404を返す
    if(this.user.permission !== 0){
      this.$router.push('/404')
    }
  },
  methods: {
    changePermission(row) {
      this.sendControlLog('ユーザー一覧　権限変更', 'ユーザー一覧画面にて、権限を変更した。')
      this.users[this.users.indexOf(row)].isEditable = false
      this.temp = this.users[this.users.indexOf(row)].permission
      this.setPermission(
        this.users.indexOf(row),
        this.users[this.users.indexOf(row)].permission,
        this.users[this.users.indexOf(row)].isChatEnable,
        this.users[this.users.indexOf(row)].is_notify,
        this.users[this.users.indexOf(row)].isSeekerDisplayEnable,
        this.users[this.users.indexOf(row)].is_jobshare_filter,
      )
    },
    setPermission (index, permission, isChatEnable, isNotify, isEnableSeekerDisplay,isJobshareFilter) {
      console.debug('*** Start *** setPermission')
      console.debug('index: ' + index)
      console.debug('permission: ' + permission)
      console.debug('isChatEnable: ' + isChatEnable)
      console.debug('isNotify: ' + isNotify)
      console.debug('isEnableSkDisplay: ' + isEnableSeekerDisplay)
      console.debug('isJobshareFilter: ' + isJobshareFilter)
      this.$store.dispatch('auth/setUsers',
        {
          'email': this.users[index].email,
          'permission': permission,
          'is_chat_enable': isChatEnable,
          'is_notify': isNotify,
          'isSeekerDisplayEnable': isEnableSeekerDisplay,
          'is_jobshare_filter': isJobshareFilter,
        }
      )
      console.debug('*** End *** setPermission')
    },
    setDepartment (email, department) {
      this.sendControlLog('ユーザー一覧　所属削除', 'ユーザー一覧画面にて、所属の「削除」ボタンをクリックした。')
      this.$store.dispatch('auth/setUsers',
        {
          'email': email,
          'department': department,
          'is_add': false
        }
      )
    },
    setPosition (email, position) {
      this.sendControlLog('ユーザー一覧　役職削除', 'ユーザー一覧画面にて、役職の「削除」ボタンをクリックした。')
      this.$store.dispatch('auth/setUsers',
        {
          'email': email,
          'position': position,
          'is_add': false
        }
      )
    },
    sendEmail (data) {
      this.$store.dispatch('auth/addMember', data)
    },
    resendEmail (email, name, permission) {
      if (confirm('招待メールを再送しますが、よろしいでしょうか？') === true) {
        const data = {email: email, username: name, permission: permission, is_client: true, is_user: false}
        this.$store.dispatch('auth/reAddMember', data)
        alert('招待メールを再送しました。')
      }
    },
    getValue (flg) {
      if (flg) return 'ON'
      else return 'OFF'
    },
    changeModalCreateUser (flg) {
      this.isModalCreateUser = flg
    },
    changeModalRestoreUser (flg) {
      this.isModalRestoreUser = flg
    },
    changeModalImportUser (flg) {
      this.isModalImportUser = flg
    },
    changeModalExportUser (flg) {
      this.isModalExportUser = flg
    },
    importUser (data) {
      this.$store.dispatch('auth/importUser', data)
        .then((d) => {
          this.$store.dispatch('auth/getUsers')
            .then(() => {
              alert('インポートを完了いたしました。')
              this.changeModalImportUser(false)
            })
        })
    },
    exportUser () {
      this.$store.dispatch('auth/exportUser')
        .then((data) => {
          let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          let blob = new Blob([bom, data], { "type" : "text/csv" })
          let downLoadLink = document.createElement('a')
          downLoadLink.download = 'ユーザー情報.csv'
          downLoadLink.href = URL.createObjectURL(blob)
          downLoadLink.dataset.downloadurl = ['text/csv', downLoadLink.download, downLoadLink.href]
          downLoadLink.click()
          alert('エクスポートを完了いたしました')
          this.changeModalExportUser(false)
        })
    },
    logicalDeleteUser(index) {
      if (this.user.email == this.users[index].email) {
        alert("自分自身は削除できません。")
      } else {
        const userName = this.users[index].username
        const userEmail = this.users[index].email
        
        if (window.confirm(`${userName}様（${userEmail}）を本当に削除しますか？`)) {
          this.$buefy.dialog.alert({
            title: '削除中',
            message: '削除処理を実行しています...',
            hasIcon: true,
            icon: 'loading',
            iconPack: 'fas',
            canCancel: false
          })
          
          this.sendControlLog('ユーザー一覧　ユーザー削除', 'ユーザー一覧画面にて、ユーザーを削除した。')
          
          this.$store.dispatch('auth/setUsers',
            {
              'email': this.users[index].email,
              'is_active': false,
              'is_notify': false
            }
          ).then(() => {
            this.$buefy.dialog.close()
            this.$buefy.snackbar.open({
              message: `${userName}様（${userEmail}）をリストから削除しました`,
              type: 'is-success',
              position: 'is-top',
              duration: 5000
            })
            this.$store.dispatch('virtualOffice/sendVirtualOfficeSV', '[REFRESH]')
          }).catch(() => {
            this.$buefy.dialog.close()
            this.$buefy.snackbar.open({
              message: '削除処理中にエラーが発生しました',
              type: 'is-danger',
              position: 'is-top',
              duration: 5000
            })
          })
        }
      }
    },
    isColInUsrInfo (usr, col) {
      return this.$_.includes(
        usr.u_custom.map((obj) => {return obj.column}),
        col.pk
      )
    },
    isLastCol (usr, col, selCol) {
      let res = this.$_.filter(
        usr.u_custom,
        (obj) => {
          return obj.column === col.pk
        }
      )
      if (res.length > 0) {
        return res.sort((a, b) => {
          if (a.pk > b.pk) return -1
          else if (a.pk < b.pk) return 1
          else return 0
        })[0].pk === selCol.pk
      } else {
        return false
      }
    },
    isMatchCol (usr, col, selCol) {
      for(let ucc of usr.u_custom) {
        if(ucc.column === col.pk) {
          if(ucc.pk === selCol.pk) {
            return true
          }
        }
      }
      return false
    },
    updateUserAuthColumn (usr, col, selCol) {
      let usrContent = ''
      let usrContentPk = 0
      let isMatchFlg = false
      for (const content of usr.u_custom) {
        if (content.column === col.pk) {
          if (selCol.pk === content.pk) {
            usrContent = content.content
            usrContentPk = content.pk
            isMatchFlg = true
            break
          }
        }
      }
      if (isMatchFlg) {
        if (usrContent) {
          let updateCustom = {
            pk: usrContentPk,
            name: col.name,
            type: 0,
            content: usrContent,
            select_list: '',
            column: col.pk,
            email: usr.email
          }
          this.$store.dispatch('auth/updateUserCustomColumns', updateCustom)
        } else {
          this.$store.dispatch('auth/deleteUserCustomColumns', usrContentPk)
        }
      }
    },
    deleteUserAuthColumn (usr, col, selCol) {
      let usrContentPk = 0
      let isMatchFlg = false
      for (const content of usr.u_custom) {
        if (content.column === col.pk) {
          if (selCol.pk === content.pk) {
            usrContentPk = content.pk
            isMatchFlg = true
            break
          }
        }
      }
      if (isMatchFlg) {
        this.$store.dispatch('auth/deleteUserCustomColumns', usrContentPk)
      }
    },
    displayHeader(idx,dispFlg) {
      if((this.dispIdx == -1 || this.dispIdx == idx) && dispFlg) {
        this.dispIdx = idx
        return this.dispHeaderAuth
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-admin-setting-container {
  height: 100%;
  width: 100%;
}
.admin-table {
  height: calc(100% - 105px);
  margin: auto;
}
.admin-table-thin-menu {
  height: calc(100% - 105px);
  margin: auto;
}
h1 {
  font-weight: 700;
  font-size: 24px;
}
.blank {
  width: 150px;
}
.add-box {
  width: 600px;
  height: auto;
  padding: 30px;
  line-height: 35px;
  background-color: white;
  border: solid thin #ccc;
  border-radius: 10px;
  text-align: left;
}
.custom-label {
  padding-left: 10px !important;
  padding-right: 20px !important;
}
.isOnline {
  float: left;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: greenyellow;
  margin-top: 7px;
  margin-right: 4px;
}
.isOffline {
  float: left;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: solid thin #ccc;
  background: transparent;
  margin-top: 7px;
  margin-right: 4px;
}
img {
  min-width: 50px;
  min-height: 50px;
  width: 50px;
  height: 50px;
  max-width: 50px;
  max-height: 50px;
  object-fit: cover;
  border-radius: 10px;
  border: solid thin #ccc;
}
.subtitle {
  font-size: medium;
}
.button-wrapper {
  text-align: right;
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 10px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.modal-header-title {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/UserAdminSetting.vue